/**
 * Focus Version & Deployment
 *
 * Versión centralizada de Focus Shell.
 * Usada por el API de entitlements para filtrar apps
 * cuyo min_focus_version sea mayor que la versión actual.
 *
 * DEPLOYMENT_ID identifica este deploy (focus, focus-bcol, etc.).
 * Controla qué organizaciones pueden acceder a esta instancia.
 * Se configura via VITE_DEPLOYMENT_ID en env vars.
 * Default: 'focus' (deploy principal).
 *
 * IMPORTANTE: Mantener FOCUS_VERSION sincronizada con package.json "version".
 */

export const FOCUS_VERSION = '0.4.0'

export const DEPLOYMENT_ID = import.meta.env.VITE_DEPLOYMENT_ID || 'focus'
